import React from 'react';
import { styled } from 'styled-components';
import { Tag, User } from '../../../../types';
import Flex from '../../../layout/Flex';
import Person from '../../../Person';
import Tags from '../../../Tags';
import Text from '../../../Text';
import Sections from '../../../layout/Sections';

interface BlogDetailsProps {
  users: User[],
  tags: Tag[],
  withEmail?: boolean,
}

const StyledBlogDetails = styled.div`
  border-block: 1px solid var(--color-iron-300);
  margin-bottom: var(--baseline);
  padding-block: var(--baseline);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: var(--gutter);
`;

export default function BlogDetails({ users, tags, withEmail }: BlogDetailsProps) {
  return (
    <StyledBlogDetails>
      <Sections $rowGap="space-sm">
        {users.map(user =>
          <Person
            key={user.id}
            name={user.name}
            email={withEmail ? user.email : undefined}
            image={user.image}
            userId={user.id}
            position={<Text en={user.position} />}
          />
        )}
      </Sections>
      <Flex $justify={{ sm: 'flex-start', md: 'flex-end' }}>
        <Tags tags={tags} />
      </Flex>
    </StyledBlogDetails>
  );
}
